/** @jsx jsx */
import { Children, cloneElement } from 'react';
import { ClassNames, css, jsx } from '@emotion/core';
import { B100, N0 } from '@atlaskit/theme/colors';
var baseFocusStyles = css({
  boxShadow: "0 0 0 2px ".concat("var(--ds-background-default, ".concat(N0, ")"), ", 0 0 0 4px ").concat("var(--ds-border-focus, ".concat(B100, ")")),
  outline: 'none'
});
var baseInsetStyles = css({
  boxShadow: "inset 0px 0px 0px 2px ".concat("var(--ds-border-focus, ".concat(B100, ")")),
  outline: 'none'
});
var focusRingStyles = css({
  '&:focus-visible': baseFocusStyles,
  '@supports not selector(*:focus-visible)': {
    '&:focus': baseFocusStyles
  },
  '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
    '&:focus-visible': {
      outline: '1px solid'
    }
  }
});
var insetFocusRingStyles = css({
  '&:focus-visible': baseInsetStyles,
  '@supports not selector(*:focus-visible)': {
    '&:focus': baseInsetStyles
  },
  '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
    '&:focus-visible': {
      outline: '1px solid',
      outlineOffset: '-1px'
    }
  }
});
/**
 * __Focus ring__
 *
 * A focus ring is used indicate the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 */

var FocusRing = function FocusRing(_ref) {
  var children = _ref.children,
      isInset = _ref.isInset;
  return jsx(ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return Children.only(
    /*#__PURE__*/
    // eslint-disable-next-line @repo/internal/react/no-clone-element
    cloneElement(children, {
      className: cx([css(isInset ? insetFocusRingStyles : focusRingStyles), children && children.props.className])
    }));
  });
};

export default FocusRing;